import { render, staticRenderFns } from "./eventTags.vue?vue&type=template&id=702114e6&scoped=true"
import script from "./eventTags.vue?vue&type=script&lang=js"
export * from "./eventTags.vue?vue&type=script&lang=js"
import style0 from "./eventTags.vue?vue&type=style&index=0&id=702114e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702114e6",
  null
  
)

export default component.exports